import React from 'react';
//import css from './css.module.less';
import { LinkModuleType } from '@/src/types/common/linkType';
import { ResponsiveRichEdit } from 'src/components/Modules/Components';
import { useDispatch } from 'react-redux';
import {
  getCollapseOpenStatus,
  EnumCollapseId,
  getCollapseValidationMsgDisplay,
  onErrorChange,
  getSubmitStamp,
  onCollapseOpen,
  onTextChange,
  getText,
} from '../slice';
import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';
import { permissions } from 'src/pages/SalesCannelVersion/SalesChannelEditorMaintenancePage/tools';

const Text = (props) => {
  const d = useDispatch();
  const { data, isConvertible, saleChannelUuid } = props;

  const { edit_maintenance_page } = permissions(saleChannelUuid);
  const handleOnChange = (obj) => {
    const { content } = obj;
    d(onTextChange(content));
  };
  //const { text, textBoxWidth, fontSizeMultiply, textAlignment } = data;
  return (
    <ResponsiveRichEdit
      hideWidth
      isConvertible={isConvertible}
      content={data}
      onChange={handleOnChange}
      disabled={!edit_maintenance_page}
      linkSet={{
        scopeVariables: { SalesChannel: saleChannelUuid },
        linkTypeFilter: [LinkModuleType.None, LinkModuleType.LinkLibrary],
      }}
    />
  );
};

export default ErrorProcessingHOC(Text, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.text,
  getContent: getText,
  title: 'Text',
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
  //   validation: (x, validationProps) => {
  //     const { isPrimary } = validationProps || {};

  //     return validateMaintenanceLongCanvas(x, !isPrimary);
  //   },
  getSubmitStamp,
});
